<template>
  <div class="p-8 -mr-6 -mb-8  bg-white rounded-md shadow max-w-10xl gridView"  style="width:95%; height: 100%;">
    <div class="cards" style="float:left;"
             :style="{ backgroundImage:`url(/downloadFile/tv_scherm_horizontaal.jpg)`, backgroundSize: `88% auto`, backgroundPositionY: `5px`}"> 
              <p style="background: white; padding: 5px;">
                <ul>
                  <li class="p-1">TV Scherm liggend</li>
                  <!-- <li><a href="/images/tv_scherm_horiz.jpg"> Download </a></li> -->
                  <li class="p-1">  
                    <a class="btn-indigo" v-on:click="logDownloadFile('tv_scherm_horiz.jpg')" :href="'/images/tv_scherm_horiz.jpg'" target="_blank" >
                        View/Download
                    </a>  
                  </li>
                </ul>
              </p>
    </div>
    
    <div class="cards" style="float:left;"
             :style="{ backgroundImage:`url(/downloadFile/tv_scherm_verticaal.jpg)`, backgroundSize: `95% auto`, backgroundPositionY: `30%`}"> 
              <p style="background: white; padding: 5px;">
                <ul>
                  <li class="p-1">TV Scherm staand</li>
                  <li class="p-1">  
                    <a class="btn-indigo" v-on:click="logDownloadFile('tv_scherm_vert.jpg')" :href="'/images/tv_scherm_vert.jpg'" target="_blank" >
                      View/Download
                    </a>  
                       <!-- <button :click="downloadImg('/images/tv_scherm_vert.jpg')"> Download </button>  -->
                  </li>
                </ul> 
              </p>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import axios from 'axios'

export default {
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  methods :{
    // downloadImg(url) {
    //   let url = url;
    //   fetch(url)
    //     .then((response) => response.blob())
    //     .then((blob) => {
    //       saveAs(blob, 'image_name.jpg');
    //     });
    //   console.log('downloading', url);
    // }
    logDownloadFile(file){
        axios.get('/displayFileLog').then(function (response) {
            
        }).catch(function (error) {
          // handle error
          console.log(error)
        }).finally(function () {
          // always executed
        });
    },
    downloadImg(responseUrl) {
        const url = window.URL.createObjectURL(new Blob([responseUrl]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.jpg"); //or any other extension
        document.body.appendChild(link);
        link.click();
    },
  }
}
</script>
<style scoped>
.cards{
  width:215px;
  height:240px;
  background:#fff;
  margin:20px;
  border-radius:0.375rem;
  /* box-shadow:0px 0px 15px 0px #313131; */
  border: 1.5px solid #e2e8f0;
  background-size:102%;
  background-repeat:no-repeat;
  background-position:top center;
  position:relative;
  overflow:hidden;
}
.bottom-bar{
  width:100%;
  height:45px;
  position:absolute;
  bottom:-100%;
  background:#fff;
  transition:all 0.3s;
  text-align:center;
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:99;
  border-top:1px solid #3333;
}
.cards:hover .bottom-bar{
  bottom:0px;
}
.cards a{
  cursor:pointer;
  padding:5px 10px;
  border-radius:4px;
  color:whitesmoke;
}
.cards a:hover{
  background:#3333;
  color:white;
}
.cards p{
  text-align:center;
  position:absolute;
  width:100%;
  bottom:5px;
  /* font-size:18px; */
  color:#39415a;
}
.gridView{
    display: flow-root;
    margin-bottom: 3%;
  }
/******************RESPONSIVE***********************/
@media screen and (max-width:500px){
  .gridView{
    display: grid;
    justify-content: center;
  }
  .cards{
    margin:15px 5px;
    width:215px;
    height:240px;
  }
  .bottom-bar{
    height:46px;
  }
}
</style>
